const Vercel_Domain = 'https://mp-back-end.vercel.app';
const Local_Domain = 'http://localhost:3001';
const isLive = true; // Set to false for local testing

// Set Domain based on the isLive flag
const Domain = isLive ? Vercel_Domain : Local_Domain;
const Version = 'v1';

const requests = {
  // Headers
  key: process.env.REACT_APP_API_KEY,
  authantication: process.env.REACT_APP_AUTHANTICATION,

  // API Urls
  login: `${Domain}/${Version}/auth`,
  uploadFile: `${Domain}/${Version}/file/upload-file`,
  testimonial: `${Domain}/${Version}/testimonial`,
  portfolio: `${Domain}/${Version}/file/portfolio/all`,
  deleteAndAddImage: `${Domain}/${Version}/file/portfolio`,
  logs: `${Domain}/${Version}/logs`,
  commonData: `${Domain}/${Version}/commondata`,
  ourSupport: `${Domain}/${Version}/oursupport`,
  partners: `${Domain}/${Version}/partners`,
  faq: `${Domain}/${Version}/faq`,
};

export default requests;